import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";

import { url } from "src/app/config/config";
import { catchError, map, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ColumnManagerService {
  // private myurl = 'https://demo.qualitapp.com/ws/column_manager/';
  private myurl = url + "column_manager/";

  constructor(private http: HttpClient) {}

  fetchRow(columnName: string, columnValue: string, database: string) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    return this.http
      .get(`${this.myurl}getLineByColumnName.php`, {
        headers: headers,
        params: {
          column_name: columnName,
          column_value: columnValue,
          database: database,
        },
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  fetchColumnComments(tableName: string) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
    
    
    return this.http
      .get(`${this.myurl}getCommentsFromTable.php`, {
        headers: headers,
        params: { table_name: tableName },
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  fetchTableComment(tableName: string) {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");
  
    return this.http
      .get(`${this.myurl}getTableComment.php`, {
        headers: headers,
        params: { table_name: tableName },
      })
      .pipe(
        map((resp) => {
          return resp;
        })
      );
  }

  fetchTableStructure(tableName: string): Observable<any> {
    let headers = new HttpHeaders();
    headers.append("Content-Type", "application/json");

    return this.http.get(`${this.myurl}getStructureTable.php`, {
      headers: headers,
      params: { table_name: tableName },
    }).pipe(
      map((resp: any) => {
        if (resp.status === 200) {
          return resp.columns_info;
        } else {
          throw new Error(resp.message);
        }
      })
    );
  }
}
